'use strict';

angular.module('internal.inspections')
    .directive('internalInspectionResourceNavigation', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'inspections/components/resource-navigation/resource-navigation.html',
            replace: true,
            controller: 'InternalNavigation'
        };
    }])
;